import { Input, Component } from '@angular/core';
import { SelectTreeComponent } from './select-tree.component';
import { TreeItem } from '../dossier/tree';


@Component({
  selector: 't-select-tree-item',
  templateUrl: './select-tree-item.component.html',
})
export class SelectTreeItemComponent {
  @Input() item: TreeItem
  @Input() treeComponent: SelectTreeComponent

  toggle() {
    this.item.closed = !this.item.closed;

    return false;
  }

  toggleChecked() {
    this.item.toggleChecked();
    
    this.treeComponent.emitSelectedLinksChange();

    return false;
  }

  selectedGroupChanged() {
    this.treeComponent.emitSelectedLinksChange();
  }
}